import { PropsWithChildren, useCallback, useState } from 'react';

import { useUserSettings } from '@queries';
import { Inline, StatusBox, u } from '@ui';

import { LoadingScreen } from '../LoadingScreen/LoadingScreen';

import { UserWelcomeWizard } from './UserWelcomeWizard';

export const UserWelcomeWizardProvider = ({ children }: PropsWithChildren) => {
    const { data: userSettings, isLoading, isError } = useUserSettings();
    const [isDismissed, setIsDismissed] = useState(false);

    const handleAction = useCallback(() => {
        window.location.reload();
    }, []);

    if (isLoading) {
        return <LoadingScreen message="Loading User settings" />;
    }

    if (isError) {
        return (
            <Inline pt={u(8)} width="100%" alignItems="center" justifyContent="center">
                <StatusBox
                    style={{ maxWidth: 800 }}
                    status="error"
                    title="We’re in the bunker"
                    description="Something went wrong loading your account. Give it another shot by refreshing the page."
                    action={{ label: 'Refresh', handleAction }}
                />
            </Inline>
        );
    }

    if (userSettings === null && !isDismissed) {
        return <UserWelcomeWizard onDismiss={() => setIsDismissed(true)} />;
    }

    return children;
};
